import React from "react";
import "../../css_files/Homepage/LoadingScreen.css";

function LoadingScreen() {
  return (
    <div className="loading-screen">
      <i class="fa-solid fa-spinner fa-3x fa-spin"></i>
    </div>
  );
}

export default LoadingScreen;
